export const RESET_PASSWORD = 'personnel/RESET_PASSWORD';
export const TOGGLE_ACTIVITY = 'personnel/TOGGLE_ACTIVITY';
